<template>
  <b-row>
    <b-col v-for="(block, block_index) in blocks" :key="block_index" lg="6">
      <div class="section--booking-engine static">
        <div class="section--booking-engine__backdrop">
          <img :src="block.image" alt />
        </div>
        <div class="section--booking-engine__content">
          <b-container fluid>
            <vb-icon :name="'symbol_vv'" />
            <div class="d-flex flex-column align-items-start">
              <div class="section--booking-engine__heading">
                <h2 class="vb-heading d-inline-block" v-html="block.heading"></h2>
              </div>
              <div
                v-for="(text, text_index) in block.texts"
                :key="text_index"
                class="section--booking-engine__text mb-2"
                :class="{ hidden: text.hidden }"
                v-html="text.value"
              ></div>
            </div>
          </b-container>
        </div>
      </div>
      <p class="text mt-4" v-html="block.caption"></p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'static-blocks',
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
  .section--booking-engine {
    position: relative;

    & + .text {
      font-size: 0.8125rem;
    }

    .container,
    .container-fluid {
      position: relative;
      z-index: 90;
    }

    &__backdrop {
      position: absolute;
      width: 100%;
      height: 100%;
      overflow: hidden;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: $black;
        z-index: 10;
        opacity: 0.05;
      }

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
      }
    }

    &__content {
      display: block;
      width: 100%;

      .container,
      .container-fluid {
        display: flex;
        align-items: flex-start;

        & > .vb-icon {
          margin-top: 8px;
          margin-right: 10px;
        }
      }
    }

    &__heading {
      display: block;

      .vb-heading {
        background: $white;
        padding: 0 8px 0 12px;
        border-radius: $border-radius;
      }
    }

    &__text {
      display: inline-block;
      background: $white;
      padding: 0 8px 0 12px;
      border-radius: $border-radius;
      font-size: 1.25rem;
    }

    &.static {
      height: auto;
      padding: 0;

      .section--booking-engine__backdrop {
        border-radius: $border-radius-lg;
        position: static;

        img {
          position: static;
        }
      }

      .section--booking-engine__content {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        display: flex;
        align-items: flex-end;
        padding-bottom: $grid-gutter-width * 2;

        .hidden {
          visibility: hidden;
        }

        .container-fluid {
          @include media-breakpoint-down(md) {
            .hidden {
              display: none;
            }
          }
        }
      }
    }
  }
</style>
